// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseRescheduleModalSuccessStage_root__U9kgU","success":"CoursePauseRescheduleModalSuccessStage_success__YrI1o"};